import { Container, Row, Col, Card } from 'react-bootstrap';
import { DollarSign, Shield, Calendar } from 'lucide-react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: DollarSign,
      title: "Earn Extra Income",
      description: "Turn your unused items into a steady income stream. Our lenders earn an average of ₹40,000+ per month."
    },
    {
      icon: Shield,
      title: "Protected & Insured",
      description: "All rentals are covered by our comprehensive insurance policy. Your items are protected against damage or loss."
    },
    {
      icon: Calendar,
      title: "Flexible Schedule",
      description: "You control when your items are available. Set your own schedule and rental terms that work for you."
    }
  ];

  return (
    <section className="section-padding" style={{ backgroundColor: 'white' }}>
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold mb-4" style={{ color: 'var(--text-dark)', letterSpacing: "-2.4px" }}>
            Why Lend on Shaxify?
          </h2>
          <p className="mx-auto text-gray fs-5" style={{lineHeight:"28px"}}>
            Join a trusted community and start earning from items that would otherwise sit
            unused          </p>
        </div>

        <Row className="g-4">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <Col md={4} key={index}>
                <Card className="h-100 border-0  card-hover text-start " >
                  <Card.Body className="p-4 rounded border-light-green icon-card">
                    <div
                      className="rounded d-flex align-items-center justify-content-center  mb-4 bg-light-green text-dark-green"
                      style={{
                        width: '48px',
                        height: '48px',

                      }}
                    >
                      <Icon size={24} className='benefits-icon'/>
                    </div>
                    <Card.Title className="fs-4 mb-3 fw-bold" style={{ color: 'var(--text-dark)' }}>
                      {benefit.title}
                    </Card.Title>
                    <Card.Text style={{ color: 'var(--text-muted)', lineHeight: '1.6', fontSize: '14px' }}>
                      {benefit.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default BenefitsSection;